import { useCallback, useEffect } from 'react';
import ReactGA from 'react-ga';

const useTracker = (location = window.location, options = {}) => {
  const trackPage = useCallback((page) => {
    ReactGA.set({
      page,
      ...options,
    });

    ReactGA.pageview(page);
  }, [options]);

  useEffect(() => {
    const page = location.pathname + location.search;

    trackPage(page);
  }, [location.pathname, location.search, trackPage]);
};

export default useTracker;
